import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import { FILTER_FIELDS, SEARCH_SAVE_TYPE } from './clientPricingHistoryConstants';
import { childClientsText } from './clientPricingHistoryHelpers';
import type { FilterOptions } from './clientPricingHistoryTypes';

const toSelectValues = (values: string[]) => values.map((value) => ({ label: value, value }));

// The parts of a search-params class the standard Filters panel (GeneralSearchPanelFigma) reads: its fields and the
// category its saved filters are kept under. Built on every render rather than declared statically, so the filter
// lists offer the values the server returned for the current selection. The currency and the columns are not here:
// they sit in the tab's toolbar.
export const searchParamsTypeFor = (childClientCount: number, options: FilterOptions | null) => ({
  saveType: SEARCH_SAVE_TYPE,
  fieldsInSearchBox: [
    {
      fieldName: 'IncludeChildClients',
      label: `Include ${childClientsText(childClientCount)}`,
      className: 'col-12',
      type: InputTypesEnum.Checkbox,
      hide: childClientCount === 0,
    },
    ...FILTER_FIELDS.map(({ key, optionsKey, label }) => ({
      fieldName: key,
      label,
      className: 'col-12',
      type: InputTypesEnum.MultiChoice,
      options: toSelectValues(options ? options[optionsKey] : []),
    })),
  ],
});
